import { render, staticRenderFns } from "./EntitlementProfiles.vue?vue&type=template&id=c700a346"
import script from "./EntitlementProfiles.vue?vue&type=script&lang=js"
export * from "./EntitlementProfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports